import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>({
  alertBox: {
    top: 0,
    position: "fixed",
    width: "98%",
    zIndex: 4,
    background: "#FEFFE1",
    display: "flex",
    alignItems: "center",
  },
  alertMessage: {
    display: "flex",
    alignItems: "center",
  },
  infoBtn: {
    color: "#E9BE25",
  },
  closeBtn: {
    marginRight: "20px",
  },
  upgradeBtn: {
    marginLeft: "40px",
  },
});
